import { type ReactNode } from 'react';

import styles from './GallerySliderAddonsLayout.css';

export function GallerySliderAddonsLayout({
  topLeft,
  topRight,
  bottomRight,
}: {
  topLeft?: JSX.Element;
  topRight?: JSX.Element;
  bottomRight?: JSX.Element;
}): ReactNode {
  if (!topLeft && !topRight && !bottomRight) {
    return null;
  }

  return (
    <>
      {topLeft && <div className={styles['top-left-addon']}>{topLeft}</div>}
      {topRight && <div className={styles['top-right-addon']}>{topRight}</div>}
      {bottomRight && <div className={styles['bottom-right-addon']}>{bottomRight}</div>}
    </>
  );
}
